module.exports = __webpack_public_path__ + "components/page-header/static/tide-badge--light-b793be5ed16d00abe750fd5667486635.svg";